import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../lib/api";
import BottomNav from "../components/BottomNav";
import { ScrollText, Sparkles, ArrowLeft, Plus } from "lucide-react";

export default function AnalysesHistory() {
  const nav = useNavigate();
  const [list, setList] = useState(null);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/analyses"); setList(data); }
      catch { setList([]); }
    })();
  }, []);

  return (
    <div className="app-shell bg-aurora min-h-screen pb-nav" data-testid="analyses-page">
      <div className="px-6 pt-10 pb-5 flex items-center gap-3">
        <button onClick={() => nav("/home")} className="text-[#5F7F77]"><ArrowLeft size={20} strokeWidth={1.7} /></button>
        <div>
          <p className="text-xs uppercase tracking-[0.18em] text-[#5F7F77] font-medium">Tvá historie</p>
          <h1 className="font-display text-3xl text-[#1A2924]">Moje analýzy</h1>
        </div>
      </div>

      <div className="px-6">
        <Link to="/analyze" data-testid="new-analysis-btn">
          <div className="rounded-3xl p-5 bg-gradient-to-br from-[#082A24] to-[#0F3D34] text-white shadow-md flex items-center gap-3 active:scale-[0.98] transition mb-5">
            <div className="w-11 h-11 rounded-2xl bg-white/15 flex items-center justify-center"><Plus size={20} strokeWidth={1.8} /></div>
            <div className="flex-1">
              <p className="font-display text-lg">Nová analýza</p>
              <p className="text-xs text-white/75">Analyzuj další konverzaci</p>
            </div>
            <Sparkles size={18} />
          </div>
        </Link>

        {list === null && [...Array(2)].map((_, i) => <div key={i} className="h-24 rounded-3xl shimmer mb-3" />)}
        {list?.length === 0 && (
          <div className="glass-card p-10 text-center text-[#5F7F77]" data-testid="no-analyses">
            <ScrollText size={36} className="mx-auto mb-3 text-[#5F7F77]" strokeWidth={1.5} />
            <p className="text-sm">Zatím žádné analýzy.<br />Klikni na „Nová analýza" a začni.</p>
          </div>
        )}

        <div className="space-y-3">
          {list?.map((a) => {
            const score = a.result?.relationship_score?.overall || 0;
            const verdict = a.result?.verdict || {};
            const flags = (a.result?.red_flags || []).length;
            return (
              <Link key={a.id} to={`/analyses/${a.id}`} data-testid={`history-${a.id}`}>
                <div className="glass-card p-4 active:scale-[0.98] transition flex items-start gap-3">
                  <div className="w-12 h-12 rounded-2xl bg-[#FFE4CC] flex items-center justify-center shrink-0 text-xl">
                    {verdict.icon?.split(" ")[0] || "💬"}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-display text-base text-[#1A2924] leading-tight">
                      {a.their_name || "Konverzace"} <span className="text-xs text-[#5F7F77]">· {a.source}</span>
                    </p>
                    <p className="text-xs text-[#5F7F77] mt-0.5">{verdict.headline || "Analýza"}</p>
                    <div className="flex items-center gap-3 mt-2 text-[0.7rem]">
                      <span className="pill">{score}% celkem</span>
                      {flags > 0 && <span className="pill text-rose-700 border-rose-200 bg-rose-50">🚩 {flags}</span>}
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>

      <BottomNav />
    </div>
  );
}
